import { render, staticRenderFns } from "./CoursesAndProgrammes.vue?vue&type=template&id=154a822e&scoped=true"
import script from "./CoursesAndProgrammes.vue?vue&type=script&lang=js"
export * from "./CoursesAndProgrammes.vue?vue&type=script&lang=js"
import style0 from "./CoursesAndProgrammes.vue?vue&type=style&index=0&id=154a822e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "154a822e",
  null
  
)

export default component.exports